import { defineComponent, computed } from "vue";
import { p as pick } from "../../../vendor-2b2dbafd.mjs";
import { g as getGradientBackground } from "../../services/color/utils-e7c3fc9a.mjs";
import { u as useRouterLinkProps, a as useRouterLink } from "../../composables/useRouterLink-48153ec5.mjs";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset-0dfbd395.mjs";
import { u as useColors } from "../../composables/useColors-6d98be99.mjs";
import { u as useTextColor } from "../../composables/useTextColor-d6b2d8c3.mjs";
import { u as useBem } from "../../composables/useBem-33d80128.mjs";
const _sfc_main = defineComponent({
  name: "VaCard",
  props: {
    ...useRouterLinkProps,
    ...useComponentPresetProp,
    tag: { type: String, default: "div" },
    square: { type: Boolean, default: false },
    outlined: { type: Boolean, default: false },
    bordered: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    href: { type: String, default: "" },
    target: { type: String, default: "" },
    stripe: { type: Boolean, default: false },
    stripeColor: { type: String, default: "" },
    gradient: { type: Boolean, default: false },
    textColor: { type: String },
    color: { type: String, default: "background-secondary" }
  },
  setup(props) {
    const { getColor } = useColors();
    const { isLinkTag, tagComputed, hrefComputed } = useRouterLink(props);
    const { textColorComputed } = useTextColor();
    const stripeColorComputed = computed(() => getColor(props.stripeColor));
    const classComputed = useBem("va-card", () => ({
      ...pick(props, ["square", "outlined", "disabled", "stripe"]),
      noBorder: !props.bordered,
      link: isLinkTag.value
    }));
    const cardStyles = computed(() => {
      const background = props.gradient && props.color ? getGradientBackground(getColor(props.color)) : getColor(props.color);
      return {
        background,
        color: textColorComputed.value
      };
    });
    return {
      classComputed,
      cardStyles,
      stripeColorComputed,
      tagComputed,
      hrefComputed
    };
  }
});
export {
  _sfc_main as _
};

import '../../../VaCard.css';
//# sourceMappingURL=VaCard.vue_vue_type_script_lang-c814b43d.mjs.map
